import { call } from 'redux-saga/effects';
import { addFormSubmitSagaTo } from 'redux-form-submit-saga';
import { makeRestartable } from 'utils/redux/saga';
import pages from './pages';
import pending from './pending';
import contents from './contents';
import deployments from './deployments';

const rootSagas = [pages, pending, contents, deployments].map(makeRestartable);

function* root() {
  yield rootSagas.map(saga => call(saga));
}

export default addFormSubmitSagaTo(root);



// WEBPACK FOOTER //
// ./src/modules/catalog/sagas/index.js